<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import {
  NumberFieldIncrement as RekaNumberFieldIncrement,
  type NumberFieldIncrementProps,
  useForwardProps,
} from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { Plus } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = defineProps<NumberFieldIncrementProps & { class?: HTMLAttributes['class'] }>()
const delegated = reactiveOmit(props, 'class')
const forwarded = useForwardProps(delegated)
</script>

<template>
  <RekaNumberFieldIncrement
    data-slot="increment"
    v-bind="forwarded"
    :class="
      cn(
        'absolute top-1/2 -translate-y-1/2 right-0 p-3 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed',
        props.class,
      )
    "
  >
    <slot>
      <Plus class="size-4" />
    </slot>
  </RekaNumberFieldIncrement>
</template>
